import React from 'react';
// import ATMLoadingButton from 'src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton';
import ATMPageHeader from 'src/components/UI/atoms/ATMPageHeader/ATMPageHeader';
import ATMPagination from 'src/components/UI/atoms/ATMPagination/ATMPagination';
import ATMTable, {
  columnTypes,
} from 'src/components/UI/atoms/ATMTable/ATMTable';
import SideNavLayout from 'src/components/layouts/SideNavLayout/SideNavLayout';
// import { setDateFilter } from "src/redux/slices/FranchiseSlice";

import {  useSelector } from "react-redux";
import { RootState } from "src/redux/store";
// import ATMDatePicker from 'src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker';
// import { CSVLink } from 'react-csv';
import moment from 'moment';
import ATMExportButton from 'src/components/UI/atoms/ATMExportButton/ATMExportButton';
import { formatedDateTimeIntoIst } from 'src/utils/formUtils/dateTimeFormate';
import FranchiseFilterDialogWrapper from './FilterDialog/FranchiseFilterDialogWrapper';
import { useNavigate } from 'react-router-dom';

type Props = {
  columns: columnTypes[];
  rows: any[];
  // franchiseExceldata: any,
  getFranchiseExcel: any,
  isloadingExcel: any,
  // setfranchiseExcel:any
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setIsOpenAddDialog: (newValue: boolean) => void;
    setSearchValue: (newValue: string) => void;
  };
};

const FranchiseListing = ({
  columns,
  rows,
  // franchiseExceldata,
  // setfranchiseExcel,
  getFranchiseExcel,
  isloadingExcel,
  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setIsOpenAddDialog,
    setRowsPerPage,
    setSearchValue,
  },
}: Props) => {
  const { dateFilter } = useSelector((state: RootState) => state.franchise);
  // const dispatch = useDispatch();
  const [franchiseExcel, setfranchiseExcel] = React.useState([])
  const [openFilterDialog, setOpenFilterDialog] = React.useState<boolean>(false);
  const franchiseExceldata = franchiseExcel?.map((ele: any) => {
    const { __v, _id, isDeleted, isActive, createdAt, ...rest } = ele;
    return { createdAt: formatedDateTimeIntoIst(createdAt, "DD MMM yyyy"), ...rest };
  });
  const navigate = useNavigate()
  return (
    <SideNavLayout>
      <div className='flex flex-col  p-4'>
        {/* Page Header */}
        <div className='p-4'>
          <ATMPageHeader
          moduleName='FRANCHISE'
            pageTitle='Franchise'
            isFilter
            onFilterClick={()=>setOpenFilterDialog(true)}
            searchValue={searchValue}
            onSearchChange={setSearchValue}
            buttonProps={{
              btnName: "Add New",
              onClick: () => {
                setIsOpenAddDialog(true);
              },
            }}
          />
        </div>

        <div className="flex justify-between items-center mx-3 my-1 mb-4">
          <div>
            <div className="flex justify-end items-center ">
              {/* <div className="flex gap-2  items-center">
                <div className="min-w-[200px] max-w-[200px]">
                  <ATMDatePicker
                    name=""
                    value={dateFilter.start_date}
                    onChange={(value) => {
                      dispatch(
                        setDateFilter({ ...dateFilter, start_date: value })
                      );
                    }}
                    label="Start Date"
                  />
                </div>

                <div className="min-w-[200px] max-w-[200px]">
                  <ATMDatePicker
                    name=""
                    value={dateFilter.end_date}
                    onChange={(value) => {
                      dispatch(
                        setDateFilter({ ...dateFilter, end_date: value })
                      );
                    }}
                    label="End Date"
                    minDate={
                      dateFilter.start_date
                        ? new Date(dateFilter.start_date)
                        : undefined
                    }
                  />
                </div>
                {dateFilter?.start_date || dateFilter?.end_date ? (
                  <div>
                    <button
                      type="button"
                      className={`rounded bg-primary-main text-white py-2 px-2 mt-4`}
                      onClick={() => {
                        dispatch(
                          setDateFilter({ start_date: null, end_date: null })
                        );
                      }}
                    >
                      Clear Date Filter
                    </button>
                  </div>
                ) : null}
              </div> */}
            </div>
          </div>

          {/* <CSVLink
            data={franchiseExceldata || []}
            asyncOnClick={true}
            onClick={() => {
              getFranchiseExcel({
                limit: rowsPerPage,
                searchValue: searchValue,
                params: [
                  "name",
                  "mobile",
                  "location"
                ],
                page: page,
                filterBy: [],
                dateFilter: {
                  startDate: dateFilter.start_date
                    ? moment(dateFilter?.start_date).format("YYYY-MM-DD")
                    : "",
                  endDate: dateFilter.end_date
                    ? moment(dateFilter?.end_date).format("YYYY-MM-DD")
                    : dateFilter.start_date ? moment().format("YYYY-MM-DD") : ''
                },
                orderBy: "createdAt",
                orderByValue: -1,
                isPaginationRequired: false,
              })
            }}
          >
            Download Excel
          </CSVLink> */}


          <ATMExportButton
            headers={[
              { label: "Date-Time", key: "createdAt" },
              { label: "Name", key: "name" },
              { label: "Mobile Number", key: "mobile" },
              { label: "Status", key: "approvedStatus" },

              { label: "location", key: "location" },
            ]}
            // ref={'exportRef'}
            fileName='franchise-excel.csv'
            onClick={(done) => {
              getFranchiseExcel({
                limit: rowsPerPage,
                searchValue: searchValue,
                params: [
                  "name",
                  "mobile",
                  "location"
                ],
                page: page,
                filterBy: [],
                dateFilter: {
                  startDate: dateFilter.start_date
                    ? moment(dateFilter?.start_date).format("YYYY-MM-DD")
                    : "",
                  endDate: dateFilter.end_date
                    ? moment(dateFilter?.end_date).format("YYYY-MM-DD")
                    : dateFilter.start_date ? moment().format("YYYY-MM-DD") : ''
                },
                orderBy: "createdAt",
                orderByValue: -1,
                isPaginationRequired: false,
              }).then((res: any) => {
                if (res.data?.status) {
                  setfranchiseExcel(res?.data?.data);
                  setTimeout(()=>{
                    done()
                  },1000)
                }
              })

            }}
            btnName="Export"
            loadingText="Exporting..."
            data={franchiseExceldata}
            isLoading={isloadingExcel}
          />
        </div>

        {/* Table */}
        <div className='flex-1 overflow-auto flex flex-col'>
          <ATMTable
            columns={columns}
            rows={rows}
            rowExtraClasses={() => 'min-h-[40px]'}
            isLoading={isTableLoading}
            onRowClick={(row) => navigate(`${row?._id}/order`)}
          />
        </div>

        <div className='p-4 py-2 flex justify-end'>
          <ATMPagination
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={setPage}
            onRowsPerPageChange={setRowsPerPage}
            rowCount={totalItems}
            rows={rows}
          />
        </div>
        {openFilterDialog ? <FranchiseFilterDialogWrapper onClose={()=>{setOpenFilterDialog(false)}} /> : null}
      </div>
    </SideNavLayout>
  );
};

export default FranchiseListing;